export default {"src":"/_next/static/media/telegram.d6eefdb3.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};